import { UpsellStatusType, UpsellStatusEnum } from '@modules/husleie-framework/src/types/Upsell.entity';
import { UpsellDepositAccount } from '@modules/husleie-framework/src/types/UpsellDepositAccount.entity';
import { UpsellKYC } from '@modules/husleie-framework/src/types/UpsellKYC.entity';
import ContractConversionOperations from '@modules/store/contract/static-classes/ContractConversionOperations';
import PhoneOperations from '@modules/husleie-framework/src/static-classes/PhoneOperations.class';

export default class DepositAccountUpsellConversionOperations {
  static apiToInternal(apiUpsellDepositAccount: any): UpsellDepositAccount {
    let status: undefined | UpsellStatusType;
    switch (apiUpsellDepositAccount.status) {
      case 'open':
        status = UpsellStatusEnum.OPEN;
        break;
      case 'pending':
        status = UpsellStatusEnum.SIGNING;
        break;
      case 'canceled':
        status = UpsellStatusEnum.CANCELED;
        break;
      case 'ordered':
        status = UpsellStatusEnum.ORDERED;
        break;
      case 'complete':
        status = UpsellStatusEnum.COMPLETE;
        break;
    }

    // treat unexisting kyc as KYC was already entered, ready for signing
    if (!status && !apiUpsellDepositAccount.kyc) {
      status = UpsellStatusEnum.SIGNING;
    }

    return {
      status,
      rent: ContractConversionOperations.convertAPIRentToInternal(apiUpsellDepositAccount.rent),
      deposit: apiUpsellDepositAccount.deposit,
      kyc: this.apiKYCToInternal(apiUpsellDepositAccount.kyc),
      tenant: {
        fullName: apiUpsellDepositAccount.tenant.fullName,
      },
    };
  }

  static internalToApi(upsell: UpsellDepositAccount): any {
    return {
      rent: upsell.rent,
      deposit: upsell.deposit,
      kyc: this.internalKYCToApi(upsell.kyc),
    };
  }

  static apiKYCToInternal(apiKyc: any): UpsellKYC {
    if (apiKyc) {
      const phone = PhoneOperations.splitPhone(apiKyc.phone);
      return {
        ...apiKyc,
        phone: phone ? { phonePrefix: phone.phonePrefix, phoneNumber: phone.phoneNumber } : undefined,
      };
    }
    return {};
  }

  static internalKYCToApi(kyc: undefined | UpsellKYC): any {
    if (kyc) {
      return { ...kyc, phone: PhoneOperations.combinePhone(kyc.phone?.phonePrefix, kyc.phone?.phoneNumber) };
    }
    return {};
  }
}
